import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ISapSubmittalErrorsDialogData } from '../../../../../models/common/ISapSubmittalErrorsDialogData';

@Component({
  selector: 'app-sap-submittal-errors-dialog',
  imports: [
    MatIcon,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    TranslatePipe,
    MatButtonModule
  ],
  templateUrl: './sap-submittal-errors-dialog.component.html',
  styleUrl: './sap-submittal-errors-dialog.component.scss'
})
export class SapSubmittalErrorsDialogComponent {

  get isBlockingMode(): boolean {
    return this.data.isBlockingMode;
  }

  get hasPreSubmitErrors(): boolean {
    return this.data.isProposalError || this.data.isCostReviewError || this.data.isOpportunityError || this.data.isSummaryEstimateError;
  }

  constructor(
    private readonly dialogRef: MatDialogRef<SapSubmittalErrorsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISapSubmittalErrorsDialogData
  ) { }

  /**
   * User acknowledges warnings and wants to continue with submission.
   * Closes the dialog with `true` result.
   */
  onContinue(): void {
    this.dialogRef.close(true);
  }
}
